import ReactDOMServer from "react-dom/server";
import tooltipContainerConfig from "pro-features/components/Chart/src/configs/tooltip/tooltipContainerConfig";
import { BulletTooltip } from "app/pages/industry-analysis/common/BulletTooltip";

export default ({ yAxisFormatter }) => {
    return {
        tooltip: {
            ...tooltipContainerConfig().tooltip,
            enabled: true,
            followPointer: false,
            outside: true,
            headerFormat: ``,
            useHTML: true,
            distance: 65,
            pointFormatter() {
                const genderName = this.name;
                const genderColor = this.color;
                const genderPercent = yAxisFormatter({ value: this.y });
                return ReactDOMServer.renderToString(
                    <BulletTooltip
                        name={genderName}
                        color={genderColor}
                        value={genderPercent}
                    />,
                );
            },
        },
    };
};
